<template>
  <div class="dft-title_text">
    <h4 class="dft-header">个人资产</h4>
    <div class="attr-item-box" v-for="(item,index) in value.attrsort" :key="index">
      <div class="attr-item-typedata" v-if="item == 'a4'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <div class="addImgList">
            <div class="imgList_box">
              <draggable
                tag="div"
                class="cardDrag-list-wrap comp-list"
                v-model="value.attr[item].value"
                :group="groupRight"
                animation="100"
                delay="10"
                :sort="true"
              >
                <div class="attr-list-item comp-item" v-for="(iitem) in value.attr[item].value" :key="iitem.id">
                  <i class="el-icon-s-operation" style="font-size: 12px;flex-shrink: 0;"></i>
                  <div class="goodsinfo">
                    <div>
                      {{`${iitem.name}`}}
                    </div>
                    <el-switch v-model="iitem.show" active-color="#155bd4" inactive-color="#999"></el-switch>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="attr-item-typestyle" v-else-if="item == 'a5'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <div class="temp-box">
            <el-select v-model="value.attr[item].value" placeholder="请选择" style="width: 100%;">
                <el-option label="无边白底" value="1" class="select-option"></el-option>
                <el-option label="卡片投影" value="2" class="select-option"></el-option>
                <el-option label="描边白底" value="3" class="select-option"></el-option>
                <el-option label="无边透明底" value="4" class="select-option"></el-option>
              </el-select>
          </div>
        </div>
      </div> -->
      <div class="attr-item-typestyle" v-else-if="item == 'a9' && ['1','3'].includes(value.attr['a2'].value)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">图片</el-radio-button>
            <el-radio-button label="2">颜色</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typedata" v-else-if="item == 'a10' && value.attr['a9'].value == '1' && ['1','3'].includes(value.attr['a2'].value)">
        <!-- <div class="attr-item-label">{{ value.attr[item].label }}</div> -->
        <div class="attr-item-value flex flex-column align-center">
          <el-upload
            class="avatar-uploader"
            :action="$uploadURL"
            :show-file-list="false"
            :on-success="(res, file)=>{handleChangeUploadSuccess(res, file,item)}"
            :before-upload="beforeUpload"
          >
            <div v-if="value.attr[item].value" class="ii-img avatar">
              <el-image :src="value.attr[item].value" fit="scale-down">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click.stop="handlePictureCardPreview(value.attr[item].value)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
              </span>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="img_info">建议图片尺寸1370*320</div>
        </div>
      </div>
      <div class="attr-item-typestyle " v-else-if="item == 'a12'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="0">直角</el-radio-button>
            <el-radio-button label="8px">圆角</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="['a13','a14'].includes(item)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-slider v-model="value.attr[item].value" :min="value.attr[item].min" :max="value.attr[item].max"
            show-input :show-input-controls="false" class="custon_slider" input-size="mini"></el-slider>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="['a6','a7','a11'].includes(item)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
        <div class="attr-item-value">
          <div class="colorPicker">
            <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
            <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
          </div>
        </div>
      </div>
      <div class="attr-item-typedata" v-else-if="item == 'a15' && ['3'].includes(value.attr['a2'].value)">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value flex flex-column align-center">
          <div class="img_info">建议图片尺寸500*460</div>
          <div class="addImgList">
            <div class="imgList_box">
              <div class="imgList-item" v-for="(ii,iiIndex) in value.attr[item].value" :key="iiIndex"
                >
                <div class="ii-img-box">
                  <el-image v-if="ii.img" class="ii-img" :src="ii.img" fit="scale-down"></el-image>
                  <div class="ii-img-btn">
                    <el-upload
                      class="avatar-uploader-d"
                      :action="$uploadURL"
                      :show-file-list="false"
                      :on-success="(res, file)=>{handleChangeUploadSuccess3(res, file,ii,iiIndex)}"
                      :before-upload="beforeUpload"
                    >
                      <div class="">
                        更换图片
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="ii-link-box">
                  <div class="ii-link-btn">
                    <i class="el-icon-top icon_btn" title="上移" v-if="iiIndex != 0" @click="moveUp(value.attr[item].value,iiIndex)"></i>
                    <i class="el-icon-bottom icon_btn" title="下移" v-if="iiIndex != (value.attr[item].value.length - 1)" @click="moveDown(value.attr[item].value,iiIndex)"></i>
                  </div>
                  <div class="ii-link-info">链接设置</div>
                  <div class="ii-link">
                    <el-input v-model="ii.url"></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
    <el-dialog title="预览" :visible.sync="dialogVisible">
      <img width="100%" style="height: 62vh;object-fit: contain;" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import addClassPage from '../addClassPage.vue'
export default {
  components: {
    draggable,
    addClassPage
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return { attr: {}, attrsort: [] }
      }
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      showClassDialog: false,
      dialogVisible: false,
      dialogImageUrl: '',
      groupRight: {
        name: 'itxst2',
        pull: false, // 拖出
        put: false // 拖入
      },
      // 模板默认数据--21
      assemblyAttr666: JSON.stringify(
        {
          attr: {
            a1: {
              label: '用户信息',
              value: {
                logo: 'https://img01.yzcdn.cn/upload_files/2023/07/06/Fq4fiVPqT5Ea1l59IThVNBGapfTq.png',
                name: '昵称',
                vipval: 100,
                viplevel: 'V2',
                num1: 9,
                num2: 9,
                num3: 9
              },
              sid: 'attr_s1',
              key: 'userinfo',
              type: 'data',
              tag: 'input'
            },
            a2: {
              label: '模板选择',
              value: '2',
              showList: {
                '2': '模板二',
              },
              type: 'data',
            },
            a4: {
              label: '资产信息',
              value: [
                { name: '余额', value: 0, info: '查看更多', show: true },
                { name: '积分', value: 0, info: '查看更多', show: true },
                { name: '优惠券', value: 0, info: '查看更多', show: true },
                { name: '卡', value: 0, info: '查看更多', show: false },
                { name: '钱包', value: 0, info: '查看更多', show: false }
              ],
              info: '资产信息,资产描述',
              activeIndex: 0,
              type: 'data',
            },
            a5: {
              label: '卡片样式',
              value: '1',
              sid: 'attr_s3',
              showList: {
                '1': '无边白底',
                '2': '卡片投影',
                '3': '描边白底',
                '4': '无边透明底'
              },
              type: 'style',
            },
            a6: {
              label: '数字颜色',
              value: '#000000',
              sid: 'attr_s',
              showList: {},
              default: '#000000',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a7: {
              label: '文字颜色',
              value: '#333333',
              sid: 'attr_s',
              showList: {},
              default: '#333333',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a8: {
              label: '卡片背景',
              value: '#ffffffcc',
              sid: 'attr_s',
              showList: {},
              default: '#ffffffcc',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a9: {
              label: '卡片形式',
              value: '2',
              sid: 'attr_s3',
              showList: {
                '1': '图片',
                '2': '颜色'
              },
              key: 'border-radius',
              type: 'style',
              tag: 'radio'
            },
            a10: {
              label: '图片背景',
              value: '',
              sid: 'attr_s',
              key: 'cardbg',
              type: 'data',
              tag: 'img'
            },
            a11: {
              label: '背景颜色',
              value: '#ffffff',
              sid: 'attr_s',
              showList: {},
              default: '#ffffff',
              key: 'background',
              type: 'style',
              tag: 'ColorPicker'
            },
            a12: {
              label: '卡片倒角',
              value: '8px',
              sid: 'attr_s3',
              showList: {
                '0': '直角',
                '8px': '圆角'
              },
              key: 'border-radius',
              type: 'style',
              tag: 'radio'
            },
            a13: {
              label: '页面边距',
              value: 16,
              sid: 'attr_s5',
              min: 0,
              max: 30,
              key: 'padding',
              type: 'style',
              tag: 'el-slider'
            },
            a15: {
              label: '添加图片',
              value: [{
                img: '', url: ''
              }, { img: '', url: '' }],
              sid: 'attr_s',
              key: 'cardbg',
              type: 'data',
              tag: 'img'
            }
          },
          attrsort: [
            'a1', 'a2', 'a3', 'a4', 'a15', 'a5', 'a6', 'a7', 'a8', 'a9', 'a10', 'a11', 'a12', 'a13'
          ]
        }
      )
    }
  },
  watch: {
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });

    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {

  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    },
    // 配置事件
    // 图片上传成功处理
    handleUploadSuccess (res, file, item) {
      const _imgUrl = file.response.data.url
      item.value.push(
        {
          logo: _imgUrl,
          categoryName: '',
          link: '',
          url: '',
          type: ''
        }
      )
    },
    // 修改图片上传成功处理
    handleChangeUploadSuccess (res, file, item) {
      const _imgUrl = file.response.data.url
      this.value.attr[item].value = _imgUrl
    },
    // 修改图片上传成功处理-3
    handleChangeUploadSuccess3 (res, file, ii, iiIndex) {
      const _imgUrl = file.response.data.url
      ii.img = _imgUrl
    },
    // 上移
    moveUp (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex - 1, 1, value[iiIndex])[0]
    },
    // 下移
    moveDown (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex + 1, 1, value[iiIndex])[0]
    },
    handleRemove (file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview (fileurl) {
      this.dialogImageUrl = fileurl
      this.dialogVisible = true
    },
    // 图片上传之前处理
    beforeUpload (file) {
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return  isLt2M;
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-title_text{
  width: 100%;
  box-sizing: border-box;
  padding: 8px;
}
.dft-header{
  margin: 5px 0;
}
.attr-item-box{
  // padding: 6px 10px;
  margin-bottom: 10px;
  .attr-item-typedata{
    margin: 6px 10px;
    .attr-item-label{
      margin-bottom: 5px;
    }
    .img_info{
      color: #969799;
      font-weight: 400;
      margin-top: 8px;
      white-space: pre-wrap;
      font-size: 13px;
    }
    .attr-item-value{
      .temp-box{
        display: flex;
        flex-wrap: wrap;
        .temp-item{
          width: calc((100% - 40px)/4);
          height: 90px;
          margin: 0 5px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .temp-item-img{
            width: 48px;
            height: 48px;
            margin-bottom: 8px;
          }
          .temp-item-name{
            font-weight: 400;
            font-size: 13px;
            line-height: 20px;
            text-align: center;
            color: #333;
          }
        }
        .active_temp-item{
          .temp-item-name{
            color: #155bd4;
          }
        }
      }
      .addImgList{
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .img_info{
          color: #969799;
          font-weight: 400;
          margin-top: 8px;
          white-space: pre-wrap;
          font-size: 13px;
        }
        .imgList_box{
          // padding: 12px 0;
          width: 100%;
          box-sizing: border-box;
          .imgList-item{
            border: 1px solid #e0e0e0;
            margin: 12px 0;
            padding: 4px;
            box-sizing: border-box;
            display: flex;

            .ii-link-box{
              // width: calc(100% - 80px);
              flex: 1;
              box-sizing: border-box;
              height: 100px;
              padding: 0 8px;
              display: flex;
              flex-direction: column;
              position: relative;
              .ii-link-btn{
                position: absolute;
                top: -4px;
                right: 0;
                display: flex;
                justify-content: flex-end;
                font-size: 18px;
                color: #969696;
                .icon_btn{
                  padding: 2px;
                  cursor: pointer;
                  margin: 4px;
                }
              }
              .ii-link-info{
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #999;
              }
              .ii-link{
                /deep/.el-input__inner{
                  height: 24px!important;
                }
              }
            }
          }
          .comp-item{
            width: calc(100% - 12px);
            margin: 8px 6px;
            padding: 6px 10px 6px 14px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 2px;
            display: flex;
            align-items: center;
            border-radius: 2px;
            background-color: #fff;
            box-shadow: 0 0 4px 0 rgba(10, 42, 97, .2);
            .goodsinfo{
              padding-left: 8px;
              font-size: 13px;
              flex: 1;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            cursor: grab;
            position: relative;
            .icon_btn{
              position: absolute;
              top: 8px;
              right: 16px;
              font-size: 16px;
              cursor: pointer;
              display: none;
            }
            &:hover{
              .icon_btn{
                display: block;
              }
            }
          }
        }

        .upload_btn{
          background: #efefef;
          border-radius: 2px;
          padding: 6px 10px 6px 14px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          width: -webkit-fit-content;
          width: -moz-fit-content;
          width: fit-content;
          margin: 0 auto;
          color: #333;
          cursor: pointer;
        }
      }
    }
  }
  .attr-item-typestyle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin: 6px 10px;
    .attr-item-label{
      color: #969799;
      margin-right: 12px;
    }
    .attr-item-on{
      color: #333333;
      margin-right: 8px;
      font-size: 12px;
    }
    .attr-item-value{
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

}

.resetBtn{
  font-size: 13px;
  color: #356fd4;
}
.colorPicker{
  height: 40px;
  display: flex;
  align-items: center;
}
.custon_slider{
  width: 100%;
  /deep/.el-slider__input{
    width: 60px;
  }
  /deep/.el-slider__runway.show-input{
    margin-left: 8px;
    margin-right: 80px;
  }
}
// 说明注释
.info-setby{
  position: relative;
  padding-bottom: 12px;
}
.info-set{
  position: absolute;
  bottom: 0;
  left: 0;
  color: #969799;
  font-size: 12px;
}
.info-label{
  font-size: 12px;
  flex-shrink: 0;
}
.ii-img-box{
  width: 80px;
  height: 100px;
  position: relative;
  flex-shrink: 0;
  .ii-img{
    width: 100%;
    height: 100%;
  }
  .ii-img-btn{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 20px;
    background-color: rgba($color: #000000, $alpha: .5);
    text-align: center;
    font-size: 13px;
    color: #ffffff;
    cursor: pointer;
  }
}
.avatar{
  width: 100px;
  height: 100px;
  position: relative;
  &:hover{
    .el-upload-list__item-actions{
      display: flex;
    }
  }
  .el-upload-list__item-actions{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.2);
    display: none;
    justify-content: center;
    align-items: center;
    .el-upload-list__item-preview{
      padding: 4px;
      color: #fff;
      font-size: 24px;
      box-sizing: border-box;
    }
  }
}
</style>
